import React from "react";
import moment from "moment";
import { ScheduledPlaylistCardStyle } from "./ScheduledPlaylistCard.style";

interface ScheduledPlaylistCardProps {
  playlist: any;
  scheduleType: "refresh" | "reset";
  onClick: (playlistId: string) => void;
}

const ScheduledPlaylistCard: React.FC<ScheduledPlaylistCardProps> = ({ 
  playlist, 
  scheduleType, 
  onClick 
}) => {
  const getPlaylistImage = () => {
    if (playlist.playlistData?.images?.[0]?.url) {
      return playlist.playlistData.images[0].url;
    }
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cdefs%3E%3ClinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23667eea;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23764ba2;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23grad)'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='60' fill='white' text-anchor='middle' dy='.3em'%3E♪%3C/text%3E%3C/svg%3E";
  };
  
  const getPlaylistName = () => {
    return playlist.playlistData?.name || "Playlist";
  };
  
  const getNextScheduleTime = () => {
    const time = scheduleType === "refresh" 
      ? playlist.nextrefreshtTime 
      : playlist.nextFixPlaylistTime;
    return moment(Number(time)).format("MMM DD, YYYY hh:mm A");
  };
  
  const getScheduleFrequency = () => {
    const type = playlist.type || "custom";
    return type.charAt(0).toUpperCase() + type.slice(1);
  };
  
  return (
    <ScheduledPlaylistCardStyle 
      className={`schedule-type-${scheduleType}`}
      onClick={() => onClick(playlist.playlistId || playlist.playlist_id)}
    >
      <div className="card-image-wrapper">
        <img src={getPlaylistImage()} alt={getPlaylistName()} className="card-image" />
      </div>
      
      <div className="card-content">
        <h3 className="playlist-name">{getPlaylistName()}</h3>
        
        <div className="schedule-info">
          <div className="info-row">
            <span className="info-label">Type:</span>
            <span className={`info-value type-${scheduleType}`}>
              <span className={`type-badge-inline ${scheduleType}`}>
                {scheduleType === "refresh" ? "Refresh" : "Reset"}
              </span>
            </span>
          </div>
          
          <div className="info-row">
            <span className="info-label">Frequency:</span>
            <span className="info-value">{getScheduleFrequency()}</span>
          </div>
          
          <div className="info-row">
            <span className="info-label">Next scheduled:</span>
            <span className="info-value info-value-date">{getNextScheduleTime()}</span>
          </div>
        </div>
      </div>
    </ScheduledPlaylistCardStyle>
  );
};

export default ScheduledPlaylistCard;

